import React from 'react';
import './App.css';
import './Platoon.css';
import './Activity.css';
import image_jatani from './images/platoon_jatani.jpg';
import image_room from './images/platoon_room.jpg';
import image_sentaku from './images/platoon_sentaku.jpg';
import image_platoon01 from './Reserve/platoon01.jpg';
import image_platoon02 from './Reserve/platoon02.jpg';
import image_platoon03 from './Reserve/platoon03.jpg';
import image_platoon04 from './Reserve/platoon04.jpg';
import image_platoon05 from './Reserve/platoon05.jpg';
import image_platoon06 from './Reserve/platoon06.jpg';
import image_platoon07 from './Reserve/platoon07.jpg';
import image_platoon08 from './Reserve/platoon08.jpg';
import image_platoon09 from './Reserve/platoon09.jpeg';
import image_platoon10 from './Reserve/platoon10.jpeg';
import { TagColor } from './Models';
import TagsComponent from './TagsComponent';
import { Img } from './PlatoonHomeComponent';
import T from './platoon-t.jpg'


export const PlatoonLife: React.FC = () => <div className="p-1">
    <div className="H2 mt-1"><big><strong>ひのきしん内容</strong></big></div>
    <table className="table">
        <tbody>
            <tr>
                <td className="min-width-7rem">行事関連の作業</td>
                <td>
                    本部祭典日のパイプ椅子設置や、行事などに使用するテントの設営・撤収を行います
                    <Img src={image_platoon01}/>
                    <Img src={image_platoon02}/>
                </td>
            </tr>

            <tr>
                <td>倉庫内作業</td>
                <td>
                    おやさと各所にある天理教関係の倉庫で作業を行います
                    <Img src={image_platoon03}/>
                    <Img src={image_platoon04}/>
                </td>
            </tr>

            <tr>
                <td>清掃作業</td>
                <td>
                    おやさと各所の除草や清掃を行います
                    <Img src={image_platoon05}/>
                    <Img src={image_platoon06}/>
                </td>
            </tr>

            <tr>
                <td>ひのきしん以外の風景</td>
                <td>
                    朝の出動前にはラジオ体操を行います。
                    食事は皆で美味しく頂きます。
                    <Img src={image_platoon07}/>
                    <Img src={image_platoon08}/>
                </td>
            </tr>

        </tbody>
    </table>

    <div className="H2 mt-1"><big><strong>「新しい隊服シャツの購入について」</strong></big></div>
    2025年より新しい隊服シャツが第百母屋・世話班室(1階事務所)にて販売されています。<br/>
    従来のシャツと比べてメッシュ生地で乾きやすくなっています。なお、新しい隊服シャツは洗濯は各自で洗濯してください    <br/><br/>
    カラー展開：白、ダークグレー<br/>
    価格：長袖1,000円/半袖800円<br/>
    サイズ：M、L、LL
    <br/><br/>
    第百母屋　購入受付時間（毎月2日～23日）<br/>
    月〜土　8:05〜16:00<br/>
    日・祝　8:40〜15:15
    <img src={T} className="image-max"/>
    <br/><br/>

    <div className="H2 mt-1"><big><strong>百母屋（宿舎）の設備</strong></big></div>
    <table className="table">
        <tbody>
            <tr>
                <td className="min-width-7rem">部屋</td>
                <td>20人1班ごとに部屋があります。各自の荷物を入れるロッカー付き。鍵付のロッカーは1階廊下にあります。<br/>
                    <img src={image_room} className="image-max"/>
                </td>
            </tr>

            <tr>
                <td>冷房・暖房</td>
                <td>各部屋冷暖房完備です。</td>
            </tr>

            <tr>
                <td>フリーWi-Fi</td>
                <td>各部屋・各廊下でフリーWi-Fiが使用できます</td>
            </tr>

            <tr>
                <td>浴場</td>
                <td>大浴場、サウナがあります　※サウナの稼働日は、水・土・日曜日の15時～18時</td>
            </tr>

            <tr>
                <td>洗濯機</td>
                <td>
                    浴場横に10台ほどあります。隊服・ズボン以外は各自で洗濯します（新しい隊服シャツは各自で洗濯）。<br/>
                    洗剤は各自持参してください。<br/>
                    <img src={image_sentaku} className="image-max"/>

                </td>
            </tr>

            <tr>
                <td>乾燥室</td>
                <td>2階にあり、自然乾燥です。干すための道具は持参。ハンガーは多少あります</td>
            </tr>

            <tr>
                <td>図書室</td>
                <td>2階にあります</td>
            </tr>

            <tr>
                <td>喫煙室</td>
                <td>分煙です。1階と2階にあります</td>
            </tr>
        </tbody>
    </table>
</div>